import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Box,
  Divider,
} from '@mui/material';
import { JsonToTable } from "react-json-to-table";
import CloseIcon from '@mui/icons-material/Close';
import Button from '../../components/Button/Button';

const ViewLog = ({ open, onClose, log }) => {
  const formattedLog = {
    basicInfo: {
      Timestamp: new Date(log.timestamp).toLocaleString(),
      Operation: log.operation,
      Module: log.module,
      UpdatedBy: log.email_id || '-',
      Status: log.status,
      ...(log.error && { Error: log.error })
    },
    data: log.data
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 2,
          bgcolor: 'background.paper',
        }}
      >
        Log Details
        <IconButton
          edge="end"
          color="inherit"
          onClick={onClose}
          aria-label="close"
          sx={{ ml: 2 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ p: 2, minHeight: '50vh' }}>
        <Box>
          <JsonToTable json={formattedLog} />
        </Box>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ p: 2, bgcolor: 'background.paper' }}>
        <Button onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewLog; 